/**
 * Created by mnaughton on 10/15/2015.
 */

import BaseFieldView from "core/views/Field/BaseFieldView";
import _ from "underscore";
export default BaseFieldView.extend({
  template: _.template(
    '<textarea class="form-control" name="<%-name%>"><%-value%></textarea>'
  ),

  events: {
    "change .form-control": "onChange",
    "keyup .form-control": "onChange",
  },

  getControlValue: function () {
    return this.$(".form-control").val();
  },

  setControlValue: function (value) {
    this.$(".form-control").val(value);
  },

  serialize: function () {
    return {
      name: this.field.id,
      value: this.getValue(""),
    };
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/edit/TextAreaView.js
// module id = 845
// module chunks = 1